<template>
  <div ref="frame" class="phone-frame" :style="{ height: `${SCREEN_HEIGHT * scale}px` }">
    <div
      :class="['phone-frame__screen', { 'phone-frame__screen--bordered': bordered }]"
      :style="{ transform: `scale(${scale})` }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
/*
  COR-1684: the conference app's screen at its design size (iPhone 13, 390x844),
  scaled down to fit narrower columns. The previews are laid out in app pixels so they
  stay a faithful mock whatever width the organizer's window gives them.
*/
const SCREEN_WIDTH = 390
const SCREEN_HEIGHT = 844

export default {
  name: 'phone-frame',
  props: {
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SCREEN_HEIGHT,
      scale: 1,
    }
  },
  mounted() {
    this.measure()
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(this.measure)
      this.observer.observe(this.$refs.frame)
    } else {
      window.addEventListener('resize', this.measure)
    }
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    window.removeEventListener('resize', this.measure)
  },
  methods: {
    measure() {
      const width = this.$refs.frame && this.$refs.frame.clientWidth
      if (width) this.scale = Math.min(1, width / SCREEN_WIDTH)
    },
  },
}
</script>

<style scoped>
.phone-frame {
  width: 100%;
  max-width: 390px;
  /* The screen keeps its 390 px layout box under the scale; clip it to the scaled size. */
  overflow: hidden;
}

.phone-frame__screen {
  position: relative;
  width: 390px;
  height: 844px;
  border-radius: 16px;
  overflow: hidden;
  transform-origin: top left;
}

/* Drawn over the slot, since the screen's own content would paint over a border. */
.phone-frame__screen--bordered::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 1px solid #d9d9d9;
  border-radius: 16px;
  pointer-events: none;
}
</style>
